import { getFeature } from "../utils/features";
import { setEvents } from "./events";

export const setFitGuideAnalytics = () => {
  const { isEnabled, getVariables } = getFeature("pdp-visual-fit-guide");

  if (isEnabled() && getVariables()?.bucket === "on") {
    setEvents({ events: ["event364"], trackingName: "pageLoad" });
  }
};
